module.exports = __webpack_public_path__ + "img/menu-4.6884bc84.svg";